import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE = defineFcm('psf_share_initial_above_button_message')
	.asString()
	.withDefault(undefined)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'PSF share page',
		description: 'Displays a warning above the share links',
	});
